import { render, staticRenderFns } from "./MemberDirectory.vue?vue&type=template&id=36cf4dc0&scoped=true"
import script from "./MemberDirectory.vue?vue&type=script&lang=js"
export * from "./MemberDirectory.vue?vue&type=script&lang=js"
import style0 from "./MemberDirectory.vue?vue&type=style&index=0&id=36cf4dc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf4dc0",
  null
  
)

export default component.exports